import { render, staticRenderFns } from "./scoreTrial.vue?vue&type=template&id=197b8612&scoped=true&"
import script from "./scoreTrial.vue?vue&type=script&lang=js&"
export * from "./scoreTrial.vue?vue&type=script&lang=js&"
import style0 from "./scoreTrial.vue?vue&type=style&index=0&id=197b8612&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b8612",
  null
  
)

export default component.exports